/**
 * Created by ivan on 14.07.2026
 */

const RainbowConfirmationWindow = Prefab.createWindow(
    "rainbow_confirmation_window",
    "rainbow_confirmation_window_prefab_json"
);
